import React, { useState, useMemo } from "react";
import styles from "../styles/Events.module.css";
import {
  FaRegCalendarAlt,
  FaMapMarkerAlt,
  FaRegHeart,
  FaHeart,
  FaSearch,
  FaChevronDown,
} from "react-icons/fa";
import heroImg from "../assets/images/image7.png";
import event1 from "../assets/images/c8.jpeg";
import event2 from "..//assets/images/c3.jpeg";
import event3 from "../assets/images/c5.jpeg";
import ctaBg from "../assets/images/image7.png"; 


const initialEvents = [
  {
    id: 1,
    name: "21 days prayer & fasting 2025",
    date: "August 4–24, 2025",
    location: "Zindiro",
    desc: "Experience three days of incredible music featuring top artists from around the world. Dance, sing, and create unforgettable memories.",
    img: event1,
    type: "upcoming",
    liked: false,
    category: "Prayer", // Added category
  },
  {
    id: 2,
    name: "Africa Ignite Connection 2024",
    date: "August 5–7, 2024",
    location: "Zindiro",
    desc: "Taste amazing cuisines from around the globe. Food trucks, live cooking demonstrations, and culinary competitions await!",
    img: event2,
    type: "upcoming",
    liked: false,
    category: "Connection", // Added category
  },
  {
    id: 3,
    name: "Family Week Connection",
    date: "September 10–12, 2024",
    location: "Ottawa",
    desc: "Discover incredible artworks, meet talented artists, and immerse yourself in creative workshops and interactive exhibits.",
    img: event3,
    type: "past",
    liked: false,
    category: "Connection", // Added category
  },
  {
    id: 4,
    name: "21 days prayer & fasting 2025",
    date: "August 4–24, 2025",
    location: "Europe",
    desc: "Experience three days of incredible music featuring top artists from around the world. Dance, sing, and create unforgettable memories.",
    img: event1,
    type: "upcoming",
    liked: false,
    category: "Prayer", // Added category
  },
  {
    id: 5,
    name: "Africa Ignite Connection 2024",
    date: "August 5–7, 2024",
    location: "Mbyo",
    desc: "Taste amazing cuisines from around the globe. Food trucks, live cooking demonstrations, and culinary competitions await!",
    img: event2,
    type: "upcoming",
    liked: false,
    category: "Connection", // Added category
  },
  {
    id: 6,
    name: "Family Week Connection",
    date: "September 10–12, 2024",
    location: "Karangazi",
    desc: "Discover incredible artworks, meet talented artists, and immerse yourself in creative workshops and interactive exhibits.",
    img: event3,
    type: "past",
    liked: false,
    category: "Connection", // Added category
  },
];

const tabs = [
  { key: "all", label: "All Events" },
  { key: "upcoming", label: "Upcoming" },
  { key: "past", label: "Past Events" },
];

// Categories should include all unique categories from events + "All Categories"
const categories = ["All Categories", "Prayer", "Connection"]; // Removed "Concert" as it's not used in events

export default function Events() {
  const [activeTab, setActiveTab] = useState("all");
  const [events, setEvents] = useState(initialEvents);
  const [selectedCategory, setSelectedCategory] = useState("All Categories");
  const [searchQuery, setSearchQuery] = useState("");

  // Filter events based on tab, category, and search
  const filteredEvents = useMemo(() => {
    let filtered = events;

    // Filter by tab
    if (activeTab !== "all") {
      filtered = filtered.filter((e) => e.type === activeTab);
    }

    // Filter by category - only if a specific category is selected
    if (selectedCategory !== "All Categories") {
      filtered = filtered.filter((e) => e.category === selectedCategory);
    }

    // Filter by search query
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (e) =>
          e.name.toLowerCase().includes(query) ||
          e.location.toLowerCase().includes(query) ||
          e.desc.toLowerCase().includes(query) ||
          (e.category && e.category.toLowerCase().includes(query)) // Check if category exists
      );
    }

    return filtered;
  }, [events, activeTab, selectedCategory, searchQuery]);

  // Handle like click
  const handleLike = (eventId) => {
    setEvents((prev) =>
      prev.map((event) =>
        event.id === eventId
          ? {
              ...event,
              liked: !event.liked,
            }
          : event
      )
    );
  };

  // Clear all filters
  const clearFilters = () => {
    setSelectedCategory("All Categories");
    setSearchQuery("");
  };

  const hasActiveFilters = 
    selectedCategory !== "All Categories" || searchQuery.trim() !== "";

  return (
    <div className={styles.eventsPage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <img src={heroImg} alt="CWFM Events" className={styles.heroImg} />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Events at Calvary</h1>
          <p className={styles.heroDesc}>
            Join us for worship, teaching, and fellowship. Discover what's
            happening at Calvary Wide Fellowship Ministries!
          </p>
        </div>
      </section>

      {/* Event Cards with Tabs */}
      <section className={styles.cardsSection}>
        {/* Tabs */}
        <div className={styles.tabs}>
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`${styles.tabBtn} ${
                activeTab === tab.key ? styles.active : ""
              }`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Search and Filter Bar */}
        <div className={styles.filterBar}>
          <div className={styles.searchWrapper}>
            <FaSearch className={styles.searchIcon} />
            <input
              type="text"
              placeholder="Search events by name, location, category..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={styles.searchInput}
            />
            {searchQuery && (
              <button
                className={styles.clearSearch}
                onClick={() => setSearchQuery("")}
                aria-label="Clear search"
              >
                ×
              </button>
            )}
          </div>

          <div className={styles.filterDropdown}>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className={styles.filterSelect}
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
            <FaChevronDown className={styles.dropdownIcon} />
          </div>
        </div>

        {/* Active Filters Display */}
        {hasActiveFilters && (
          <div className={styles.activeFilters}>
            <span className={styles.filterCount}>
              {filteredEvents.length} event{filteredEvents.length !== 1 ? "s" : ""} found
              {selectedCategory !== "All Categories" && ` in "${selectedCategory}"`}
              {searchQuery.trim() && ` matching "${searchQuery}"`}
            </span>
            <button className={styles.clearFiltersBtn} onClick={clearFilters}>
              Clear all filters
            </button>
          </div>
        )}

        {/* Events Grid */}
        <div className={styles.eventsGrid}>
          {filteredEvents.length === 0 ? (
            <div className={styles.noEvents}>
              <div className={styles.noEventsIcon}>📅</div>
              <h3>No events found</h3>
              <p>Try adjusting your filters or search terms</p>
              {hasActiveFilters && (
                <button className={styles.resetBtn} onClick={clearFilters}>
                  Reset Filters
                </button>
              )}
            </div>
          ) : (
            filteredEvents.map((event) => (
              <div className={styles.eventCard} key={event.id}>
                <div className={styles.eventImgWrap}>
                  <img
                    src={event.img}
                    alt={event.name}
                    className={styles.eventImg}
                  />
                  {/* Category badge - only show if event has a category */}
                  {event.category && (
                    <div className={styles.categoryBadge}>{event.category}</div>
                  )}
                </div>
                <div className={styles.eventInfo}>
                  <h3 className={styles.eventName}>{event.name}</h3>
                  <div className={styles.eventMetaWrapper}>
                    <div className={styles.eventMeta}>
                      <FaRegCalendarAlt className={styles.icon} />
                      {event.date}
                    </div>
                    <div className={styles.eventMeta}>
                      <FaMapMarkerAlt className={styles.icon} />
                      {event.location}
                    </div>
                  </div>
                  <p className={styles.eventDesc}>{event.desc}</p>
                  {/* Like button */}
                  <button
                    className={styles.likeBtn}
                    onClick={() => handleLike(event.id)}
                    aria-label={event.liked ? "Unlike event" : "Like event"}
                  >
                    {event.liked ? (
                      <FaHeart className={styles.likedIcon} />
                    ) : (
                      <FaRegHeart className={styles.likeIcon} />
                    )}
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </section>

      {/* CTA Section with Background Image */}
      <section 
        className={styles.ctaSection}
        style={{ backgroundImage: `url(${ctaBg})` }}
      >
        <div className={styles.ctaInner}>
          <h2 className={styles.ctaTitle}>Want to host or sponsor an event?</h2>
          <p className={styles.ctaDesc}>
            Contact our events team to get involved or to learn more about
            partnership opportunities at CWFM.
          </p>
          <a href="/contact" className={styles.ctaButton}>
            Contact Us
          </a>
        </div>
      </section>
    </div>
  );
}